module.exports = __webpack_public_path__ + "img/august_460.d0aa6677.png";